<template>
  <div class="transactions container" id="million-bit-transactions">
    <h1 class="pt-3 honk-text">Pixels: <span v-text="pixelCount"></span></h1>

    <div class="btn-group btn-block">
        <button type="button" class="btn btn-icon btn-block btn-primary my-3" v-on:click="toggleView()" v-bind:class="{'disabled': toggledView === 'mint'}">
            Mint
        </button>
        <button type="button" class="btn btn-icon btn-block btn-primary my-3" v-on:click="toggleView()" v-bind:class="{'disabled': toggledView === 'repaint'}">
            Repaint
        </button>
    </div>

    <table style="width: 100%;">
      <tr v-for="transaction in transactionsFiltered" v-bind:key="transaction._id">
        <td>
          <b class="mr-1">{{ transaction.seq }}</b>
          <a v-bind:href="'https://basescan.org/tx/'+transaction.hash" target="_blank"><img src="/static/external-link.svg" class="external-link" alt="View transaction"/></a>
        </td>
        <td v-lazy-load>
          <img :data-url="s3Base+transaction.hash+'-crop.jpeg'" class="mr-4 my-4" />
        </td>
        <td class="text-left link">
          <a v-bind:href="transaction.url" target="_blank">{{ transaction.url }}</a>
        </td>
        <td class="text-right">
          <div class="btn-group">
            <!-- <a v-bind:href="'https://opensea.io/assets/base/0x25b9afe64bb3593ec7e9dc7ef386a9b04c53f96e/'+transaction.tokenId" target="_blank" class="btn btn-outline-primary btn-sm">Open Sea</a> -->
            <a v-bind:href="'https://magiceden.us/item-details/base/0x25b9afe64bb3593ec7e9dc7ef386a9b04c53f96e/'+transaction.tokenId" target="_blank" class="btn btn-outline-primary btn-sm">Magic Eden</a>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
const BASE_S3_BUCKET_TRX = process.env.BASE_S3_BUCKET_TRX;
const BASE_S3_BUCKET = process.env.BASE_S3_BUCKET;
export default {
  name: 'transactions',
  data () {
    return {
      toggledView: 'mint',
      pixelCount: 0,
      transactions: [],
      transactionsFiltered: [],
      s3Base: BASE_S3_BUCKET_TRX,
      dataSrc: BASE_S3_BUCKET+'transactions.json?'+Date.now(),
    }
  },
  inject: ['updateAppRoute'],
  created: function () {
    this.updateAppRoute('list');
    axios.get(this.dataSrc)
      .then((response) => {
        this.transactions = response.data;
        this.filterTransactions();
      });
  },
  methods: {
    toggleView: function() {
      if (this.toggledView === 'mint') {
        this.toggledView = 'repaint';
      } else {
        this.toggledView = 'mint';
      }
      this.filterTransactions();
    },
    filterTransactions: function() {
      this.transactionsFiltered = this.transactions.filter(transaction => {
        return this.toggledView === 'repaint' ? transaction.isRepaint : !transaction.isRepaint;
      });
      const sum = this.transactionsFiltered.reduce((accumulator, currentObject) => {
        return accumulator + currentObject.pixels;
      }, 0);
      this.pixelCount = sum;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  img.external-link {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
  #million-bit-transactions {
    background: #fff !important;
  }
  #million-bit-transactions table tr td.link {
    overflow-wrap: anywhere;
  }
</style>
<style>
@media screen and (max-device-width: 768px) {
  #million-bit-transactions .btn, #million-bit-transactions .form-control {
    font-size: 1.5rem;
  }
  #million-bit-transactions.container {
    max-width: 98%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Transactions.vue?227b3c8b